const PRODUCTS_TABLE_READY = "products-table-ready"
const SEARCH_TEXT_STATE = "products-table-search-text-state"
const ROWS_PER_PAGE_STATE = "products-table-rows-per-page-state"
const PAGINATION_STATE = "products-table-pagination-state"

const CITY_FILTER_STATE = "products-table-city-filter-state"
const STATE_FILTER_STATE = "products-table-state-filter-state"
const PRODUCT_ID_FOR_ACTION = "products-table-product-id-for-action"


const initialState = {
    isProductsTableReady: true,
    products: {},

    previousCity: 0,
    previousState: 0,

    productSelectedId: null,
    
    previousSearchText: "",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case PRODUCTS_TABLE_READY:
            return Object.assign({}, state, { isProductsTableReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchFieldText = action.payload
            return Object.assign({}, state, duplicateState)
        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        
        case CITY_FILTER_STATE:
            return Object.assign({}, state, {previousCity:action.payload})

        case STATE_FILTER_STATE:
            return Object.assign({}, state, {previousState:action.payload})

        case PRODUCT_ID_FOR_ACTION:
            return Object.assign({}, state, {productSelectedId:action.payload})

        default:
        return state
    
    }

}

export function productsTableReady(data) {
    return {
        type: PRODUCTS_TABLE_READY,
        payload: data
    }
}

export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}

export function cityFilterState(city){
    return{
        type:CITY_FILTER_STATE,
        payload:city
    }
}

export function stateFilterState(state){
    return{
        type:STATE_FILTER_STATE,
        payload:state
    }
}

export function productIdForAction(productId){
    return{
        type:PRODUCT_ID_FOR_ACTION,
        payload:productId
    }
}


// WEBPACK FOOTER //
// ./src/modules/Products/redux/products.js